import financeServices from 'services/financeServices';

export const financeActions = {
  getFinanceStats: 'getFinanceStats',
};

export default {
  [financeActions.getFinanceStats]: {
    saga: function*({ payload = {} }) {
      const { callbacks, body = {} } = payload;
      try {
        const response = yield financeServices.getFinanceStats(body);
        callbacks && callbacks.onSuccess(response);
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
